import script from "./FavoriteGame.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoriteGame.vue?vue&type=script&setup=true&lang=js"

import "./FavoriteGame.vue?vue&type=style&index=0&id=5ee69dc9&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ee69dc9"]])

export default __exports__